import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Home from './pages/Home'
import CareersList from './pages/CareersList'
import CareersJobDetail from './pages/CareersJobDetail'
import CareersConfirm from './pages/CareersConfirm'
import Login from './pages/Login'
import UserLogin from './pages/UserLogin'
import UserPortal from './pages/UserPortal'
import AdminDashboard from './pages/AdminDashboard'
import OrganizationSettings from './pages/OrganizationSettings'
import SubsidiaryDetail from './pages/SubsidiaryDetail'
import CountriesList from './pages/CountriesList'
import CountryDetail from './pages/CountryDetail'
import UsersList from './pages/UsersList'
import RolesList from './pages/RolesList'
import AppCatalog from './pages/AppCatalog'
import FeatureFlags from './pages/FeatureFlags'
import NumberingAdmin from './pages/NumberingAdmin'
import AISettings from './pages/AISettings'
import DocumentTemplates from './pages/DocumentTemplates'
import DocumentTemplateDetail from './pages/DocumentTemplateDetail'
import FinanceAccounts from './pages/FinanceAccounts'
import FinancePartners from './pages/FinancePartners'
import FinancePartnerDetail from './pages/FinancePartnerDetail'
import FinanceInvoices from './pages/FinanceInvoices'
import FinanceInvoiceDetail from './pages/FinanceInvoiceDetail'
import FinanceJournalEntries from './pages/FinanceJournalEntries'
import FinanceJournalEntryDetail from './pages/FinanceJournalEntryDetail'
import FinancePayments from './pages/FinancePayments'
import FinancePaymentDetail from './pages/FinancePaymentDetail'
import FinanceBills from './pages/FinanceBills'
import FinanceBillDetail from './pages/FinanceBillDetail'
import FinanceBankRec from './pages/FinanceBankRec'
import FinanceCurrencies from './pages/FinanceCurrencies'
import FinanceExchangeRates from './pages/FinanceExchangeRates'
import FinanceVendorContracts from './pages/FinanceVendorContracts'
import FinanceVendorContractDetail from './pages/FinanceVendorContractDetail'
import ReportTrialBalance from './pages/ReportTrialBalance'
import ReportProfitLoss from './pages/ReportProfitLoss'
import ReportBalanceSheet from './pages/ReportBalanceSheet'
import SalesQuotes from './pages/SalesQuotes'
import SalesQuoteDetail from './pages/SalesQuoteDetail'
import SalesOrders from './pages/SalesOrders'
import SalesOrderDetail from './pages/SalesOrderDetail'
import ProcurementPurchaseOrders from './pages/ProcurementPurchaseOrders'
import ProcurementPurchaseOrderDetail from './pages/ProcurementPurchaseOrderDetail'
import InventoryProducts from './pages/InventoryProducts'
import InventoryProductDetail from './pages/InventoryProductDetail'
import InventoryWarehouses from './pages/InventoryWarehouses'
import InventoryStock from './pages/InventoryStock'
import HRDepartments from './pages/HRDepartments'
import HRDepartmentDetail from './pages/HRDepartmentDetail'
import HRPeople from './pages/HRPeople'
import HRPersonDetail from './pages/HRPersonDetail'
import HREmployees from './pages/HREmployees'
import HREmploymentDetail from './pages/HREmploymentDetail'
import HRContractorEngagementDetail from './pages/HRContractorEngagementDetail'
import HRJobProfiles from './pages/HRJobProfiles'
import HRJobProfileDetail from './pages/HRJobProfileDetail'
import HRPositions from './pages/HRPositions'
import HRPositionDetail from './pages/HRPositionDetail'
import HRTimeOff from './pages/HRTimeOff'
import HRBench from './pages/HRBench'
import CRMAccounts from './pages/CRMAccounts'
import CRMAccountDetail from './pages/CRMAccountDetail'
import CRMContacts from './pages/CRMContacts'
import CRMContactDetail from './pages/CRMContactDetail'
import CRMPipelines from './pages/CRMPipelines'
import CRMPipelineDetail from './pages/CRMPipelineDetail'
import CRMOpportunities from './pages/CRMOpportunities'
import CRMOpportunityDetail from './pages/CRMOpportunityDetail'
import CRMKanban from './pages/CRMKanban'
import CRMLeads from './pages/CRMLeads'
import CRMLeadDetail from './pages/CRMLeadDetail'
import CRMActivities from './pages/CRMActivities'
import CRMDashboard from './pages/CRMDashboard'
import ConsultingEngagements from './pages/ConsultingEngagements'
import ConsultingEngagementDetail from './pages/ConsultingEngagementDetail'
import ConsultingProjects from './pages/ConsultingProjects'
import ConsultingConsultants from './pages/ConsultingConsultants'
import ConsultantProfileDetail from './pages/ConsultantProfileDetail'
import ConsultingSkills from './pages/ConsultingSkills'
import ConsultingProjectDetail from './pages/ConsultingProjectDetail'
import ConsultingApprovals from './pages/ConsultingApprovals'
import MyWorkReports from './pages/MyWorkReports'
import ATSJobs from './pages/ATSJobs'
import ATSJobDetail from './pages/ATSJobDetail'
import ATSApplicationDetail from './pages/ATSApplicationDetail'
import ATSCandidates from './pages/ATSCandidates'
import ATSCandidateDetail from './pages/ATSCandidateDetail'
import ATSPipelines from './pages/ATSPipelines'
import ATSPipelineDetail from './pages/ATSPipelineDetail'
import AdminInvites from './pages/AdminInvites'
import InviteAccept from './pages/InviteAccept'
import AdminEmailSettings from './pages/AdminEmailSettings'
import MyNotifications from './pages/MyNotifications'
import MyNotificationPreferences from './pages/MyNotificationPreferences'
import AdminNotificationRules from './pages/AdminNotificationRules'
import AdminNotificationRuleDetail from './pages/AdminNotificationRuleDetail'
import AdminAIAgents from './pages/AdminAIAgents'
import { AdminAIAgentRunsList, AdminAIAgentRunDetail } from './pages/AdminAIAgentRuns'
import AdminAIAgentApprovals from './pages/AdminAIAgentApprovals'
import RequestsMyList from './pages/RequestsMyList'
import RequestsInbox from './pages/RequestsInbox'
import RequestsNew from './pages/RequestsNew'
import RequestDetail from './pages/RequestDetail'
import RequestTypesAdmin from './pages/RequestTypesAdmin'
import WorkflowsAdmin from './pages/WorkflowsAdmin'
import { ProtectedRoute } from './components/ProtectedRoute'

// Convenience wrappers. `requiredApp` ties each route to a row in the App
// catalog (core.App.code) — if that row has is_enabled=false the page is
// blocked for everyone including admins, until re-enabled at /admin/apps.
const ADMIN = (children: React.ReactNode) => <ProtectedRoute adminOnly>{children}</ProtectedRoute>
const FINANCE = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="finance" requiredPermissions={['finance.access']}>{children}</ProtectedRoute>
const FINANCE_REPORTS = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="finance" requiredPermissions={['finance.reports']}>{children}</ProtectedRoute>
const SALES = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="sales" requiredPermissions={['sales.access']}>{children}</ProtectedRoute>
const PROCUREMENT = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="procurement" requiredPermissions={['procurement.access']}>{children}</ProtectedRoute>
const INVENTORY = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="inventory" requiredPermissions={['inventory.access']}>{children}</ProtectedRoute>
const HR = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="hr" requiredPermissions={['hr.access']}>{children}</ProtectedRoute>
const CRM = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="crm" requiredPermissions={['crm.access']}>{children}</ProtectedRoute>
const CONSULTING = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="consulting" requiredPermissions={['consulting.access']}>{children}</ProtectedRoute>
const ATS = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="ats" requiredPermissions={['ats.access']}>{children}</ProtectedRoute>
const REQUESTS = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="requests" requiredPermissions={['requests.access']}>{children}</ProtectedRoute>
const PARTNERS = (children: React.ReactNode) =>
  <ProtectedRoute requiredApp="partners" requiredPermissions={['partners.access']}>{children}</ProtectedRoute>

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/login" element={<UserLogin />} />
        {/* Public invite acceptance — no auth required. */}
        <Route path="/invite/accept/:token" element={<InviteAccept />} />

        {/* Public careers site — no auth, gated server-side by ENABLE_CAREERS_SITE. */}
        <Route path="/careers" element={<CareersList />} />
        <Route path="/careers/jobs/:slug" element={<CareersJobDetail />} />
        <Route path="/careers/confirm/:token" element={<CareersConfirm />} />
        <Route path="/portal" element={<ProtectedRoute userOnly loginPath="/login"><UserPortal /></ProtectedRoute>} />

        <Route path="/admin/login" element={<Login />} />

        {/* Platform administration — admin-only */}
        <Route path="/admin" element={ADMIN(<AdminDashboard />)} />
        <Route path="/admin/organization" element={ADMIN(<OrganizationSettings />)} />
        <Route path="/admin/organization/subsidiaries/:id" element={ADMIN(<SubsidiaryDetail />)} />
        <Route path="/admin/countries" element={ADMIN(<CountriesList />)} />
        <Route path="/admin/countries/:id" element={ADMIN(<CountryDetail />)} />
        <Route path="/admin/users" element={ADMIN(<UsersList />)} />
        <Route path="/admin/invites" element={ADMIN(<AdminInvites />)} />
        <Route path="/admin/email-settings" element={ADMIN(<AdminEmailSettings />)} />
        <Route path="/admin/notifications/rules" element={ADMIN(<AdminNotificationRules />)} />
        <Route path="/admin/notifications/rules/:id" element={ADMIN(<AdminNotificationRuleDetail />)} />
        <Route path="/admin/ai-agents" element={ADMIN(<AdminAIAgents />)} />
        <Route path="/admin/ai-agents/runs" element={ADMIN(<AdminAIAgentRunsList />)} />
        <Route path="/admin/ai-agents/runs/:id" element={ADMIN(<AdminAIAgentRunDetail />)} />
        <Route path="/admin/ai-agents/approvals" element={ADMIN(<AdminAIAgentApprovals />)} />
        <Route path="/admin/roles" element={ADMIN(<RolesList />)} />

        {/* User-facing notification pages — any authenticated user. */}
        <Route path="/notifications" element={<ProtectedRoute>{<MyNotifications />}</ProtectedRoute>} />
        <Route path="/me/notification-preferences" element={<ProtectedRoute>{<MyNotificationPreferences />}</ProtectedRoute>} />
        <Route path="/admin/apps" element={ADMIN(<AppCatalog />)} />
        <Route path="/admin/feature-flags" element={ADMIN(<FeatureFlags />)} />
        <Route path="/admin/numbering" element={ADMIN(<NumberingAdmin />)} />
        <Route path="/admin/ai-settings" element={ADMIN(<AISettings />)} />
        <Route path="/admin/document-templates" element={ADMIN(<DocumentTemplates />)} />
        <Route path="/admin/document-templates/:id" element={ADMIN(<DocumentTemplateDetail />)} />

        {/* Partners & Contracts — own module */}
        <Route path="/admin/partners" element={PARTNERS(<FinancePartners />)} />
        <Route path="/admin/partners/:id" element={PARTNERS(<FinancePartnerDetail />)} />
        <Route path="/admin/partners/vendor-contracts" element={PARTNERS(<FinanceVendorContracts />)} />
        <Route path="/admin/partners/vendor-contracts/:id" element={PARTNERS(<FinanceVendorContractDetail />)} />

        {/* Finance — permission-gated */}
        <Route path="/admin/finance/accounts" element={FINANCE(<FinanceAccounts />)} />
        <Route path="/admin/finance/invoices" element={FINANCE(<FinanceInvoices />)} />
        <Route path="/admin/finance/invoices/:id" element={FINANCE(<FinanceInvoiceDetail />)} />
        <Route path="/admin/finance/payments" element={FINANCE(<FinancePayments />)} />
        <Route path="/admin/finance/payments/:id" element={FINANCE(<FinancePaymentDetail />)} />
        <Route path="/admin/finance/bills" element={FINANCE(<FinanceBills />)} />
        <Route path="/admin/finance/bills/:id" element={FINANCE(<FinanceBillDetail />)} />
        <Route path="/admin/finance/bank-rec" element={FINANCE(<FinanceBankRec />)} />
        <Route path="/admin/finance/currencies" element={FINANCE(<FinanceCurrencies />)} />
        <Route path="/admin/finance/exchange-rates" element={FINANCE(<FinanceExchangeRates />)} />
        <Route path="/admin/finance/journal-entries" element={FINANCE(<FinanceJournalEntries />)} />
        <Route path="/admin/finance/journal-entries/:id" element={FINANCE(<FinanceJournalEntryDetail />)} />
        <Route path="/admin/finance/reports/trial-balance" element={FINANCE_REPORTS(<ReportTrialBalance />)} />
        <Route path="/admin/finance/reports/profit-loss" element={FINANCE_REPORTS(<ReportProfitLoss />)} />
        <Route path="/admin/finance/reports/balance-sheet" element={FINANCE_REPORTS(<ReportBalanceSheet />)} />

        {/* Sales */}
        <Route path="/admin/sales/quotes" element={SALES(<SalesQuotes />)} />
        <Route path="/admin/sales/quotes/:id" element={SALES(<SalesQuoteDetail />)} />
        <Route path="/admin/sales/orders" element={SALES(<SalesOrders />)} />
        <Route path="/admin/sales/orders/:id" element={SALES(<SalesOrderDetail />)} />

        {/* Procurement */}
        <Route path="/admin/procurement/purchase-orders" element={PROCUREMENT(<ProcurementPurchaseOrders />)} />
        <Route path="/admin/procurement/purchase-orders/:id" element={PROCUREMENT(<ProcurementPurchaseOrderDetail />)} />

        {/* Inventory */}
        <Route path="/admin/inventory/products" element={INVENTORY(<InventoryProducts />)} />
        <Route path="/admin/inventory/products/:id" element={INVENTORY(<InventoryProductDetail />)} />
        <Route path="/admin/inventory/warehouses" element={INVENTORY(<InventoryWarehouses />)} />
        <Route path="/admin/inventory/stock" element={INVENTORY(<InventoryStock />)} />

        {/* HR */}
        <Route path="/admin/hr/departments" element={HR(<HRDepartments />)} />
        <Route path="/admin/hr/departments/:id" element={HR(<HRDepartmentDetail />)} />
        <Route path="/admin/hr/people" element={HR(<HRPeople />)} />
        <Route path="/admin/hr/people/:id" element={HR(<HRPersonDetail />)} />
        <Route path="/admin/hr/employees" element={HR(<HREmployees />)} />
        {/* Legacy /admin/hr/employees/:id still redirects — record page lives on Person. */}
        <Route path="/admin/hr/employees/:id" element={<Navigate to="/admin/hr/people" replace />} />
        <Route path="/admin/hr/employments/:id" element={HR(<HREmploymentDetail />)} />
        <Route path="/admin/hr/contractor-engagements/:id" element={HR(<HRContractorEngagementDetail />)} />
        <Route path="/admin/hr/job-profiles" element={HR(<HRJobProfiles />)} />
        <Route path="/admin/hr/job-profiles/:id" element={HR(<HRJobProfileDetail />)} />
        <Route path="/admin/hr/positions" element={HR(<HRPositions />)} />
        <Route path="/admin/hr/positions/:id" element={HR(<HRPositionDetail />)} />
        <Route path="/admin/hr/time-off" element={HR(<HRTimeOff />)} />
        <Route path="/admin/hr/bench" element={HR(<HRBench />)} />

        {/* CRM */}
        <Route path="/admin/crm/leads" element={CRM(<CRMLeads />)} />
        <Route path="/admin/crm/leads/:id" element={CRM(<CRMLeadDetail />)} />
        <Route path="/admin/crm/accounts" element={CRM(<CRMAccounts />)} />
        <Route path="/admin/crm/accounts/:id" element={CRM(<CRMAccountDetail />)} />
        <Route path="/admin/crm/contacts" element={CRM(<CRMContacts />)} />
        <Route path="/admin/crm/contacts/:id" element={CRM(<CRMContactDetail />)} />
        <Route path="/admin/crm/opportunities" element={CRM(<CRMOpportunities />)} />
        <Route path="/admin/crm/opportunities/:id" element={CRM(<CRMOpportunityDetail />)} />
        <Route path="/admin/crm/kanban" element={CRM(<CRMKanban />)} />
        <Route path="/admin/crm/pipelines" element={CRM(<CRMPipelines />)} />
        <Route path="/admin/crm/pipelines/:id" element={CRM(<CRMPipelineDetail />)} />
        <Route path="/admin/crm/activities" element={CRM(<CRMActivities />)} />
        <Route path="/admin/crm/dashboard" element={CRM(<CRMDashboard />)} />

        {/* Consulting */}
        <Route path="/admin/consulting/engagements" element={CONSULTING(<ConsultingEngagements />)} />
        <Route path="/admin/consulting/engagements/:id" element={CONSULTING(<ConsultingEngagementDetail />)} />
        <Route path="/admin/consulting/projects" element={CONSULTING(<ConsultingProjects />)} />
        <Route path="/admin/consulting/projects/:id" element={CONSULTING(<ConsultingProjectDetail />)} />
        <Route path="/admin/consulting/consultants" element={CONSULTING(<ConsultingConsultants />)} />
        <Route path="/admin/consulting/consultants/:id" element={CONSULTING(<ConsultantProfileDetail />)} />
        <Route path="/admin/consulting/skills" element={CONSULTING(<ConsultingSkills />)} />
        <Route
          path="/admin/consulting/approvals"
          element={
            <ProtectedRoute requiredApp="consulting" requiredPermissions={['consulting.approve_time']}>
              <ConsultingApprovals />
            </ProtectedRoute>
          }
        />

        {/* Recruitment (ATS) */}
        <Route path="/admin/ats/jobs" element={ATS(<ATSJobs />)} />
        <Route path="/admin/ats/jobs/:id" element={ATS(<ATSJobDetail />)} />
        <Route path="/admin/ats/applications/:id" element={ATS(<ATSApplicationDetail />)} />
        <Route path="/admin/ats/candidates" element={ATS(<ATSCandidates />)} />
        <Route path="/admin/ats/candidates/:id" element={ATS(<ATSCandidateDetail />)} />
        <Route path="/admin/ats/pipelines" element={ATS(<ATSPipelines />)} />
        <Route path="/admin/ats/pipelines/:id" element={ATS(<ATSPipelineDetail />)} />

        {/* Universal Requests */}
        <Route path="/admin/requests" element={REQUESTS(<RequestsMyList />)} />
        <Route path="/admin/requests/new" element={REQUESTS(<RequestsNew />)} />
        <Route path="/admin/requests/inbox" element={REQUESTS(<RequestsInbox />)} />
        <Route path="/admin/requests/types" element={ADMIN(<RequestTypesAdmin />)} />
        <Route path="/admin/requests/workflows" element={ADMIN(<WorkflowsAdmin />)} />
        <Route path="/admin/requests/:id" element={REQUESTS(<RequestDetail />)} />

        {/* My Apps (end-user self-service) */}
        <Route
          path="/my-apps/work-report"
          element={
            <ProtectedRoute requiredApp="consulting" requiredPermissions={['consulting.submit_time']}>
              <MyWorkReports />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
